"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotDivide = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotDivide = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M20.355 39.89c6.245.404 13.26-.103 17.124-4.986 3.843-4.857 2.624-11.707.738-17.59-1.664-5.19-5.317-9.255-10.164-11.812C22.9 2.785 16.686.48 11.568 3.26c-4.952 2.69-5.313 9.164-6.38 14.664-1 5.145-2.35 10.605.636 14.928 3.205 4.641 8.872 6.67 14.53 7.038Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M8.332 20h23.333m-8.332-10a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0Zm0 20a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0Z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotDivide = SpotDivide;
SpotDivide.displayName = "SpotDivide";